/*!
 * Check if two objects or arrays are equal
 * (c) 2021 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {*}       obj1 The first item
 * @param  {*}       obj2 The second item
 * @return {Boolean}       Returns true if they're equal in value
 */
const isEqual = (obj1, obj2) => {
  const getType = (obj) => {
    return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
  };
  const areArraysEqual = () => {
    if (obj1.length !== obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!isEqual(obj1[i], obj2[i])) return false;
    }
    return true;
  };
  const areObjectsEqual = () => {
    if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
    for (let key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        if (!isEqual(obj1[key], obj2[key])) return false;
      }
    }
    return true;
  };
  const areFunctionsEqual = () => {
    return obj1.toString() === obj2.toString();
  };
  const arePrimativesEqual = () => {
    return obj1 === obj2;
  };
  let type = getType(obj1);
  if (type !== getType(obj2)) return false;
  if (type === 'array') return areArraysEqual();
  if (type === 'object') return areObjectsEqual();
  if (type === 'function') return areFunctionsEqual();
  return arePrimativesEqual();
};

export { isEqual };
